import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TopComponent } from './component/pages/top/top.component';
import { CompleteComponent } from './component/pages/complete/complete.component';
import { ContactComponent } from './component/pages/contact/contact.component';
import { AboutComponent } from './component/pages/about/about.component';
import { ServiceComponent } from './component/pages/service/service.component';

const routes: Routes = [
  { path: '', component: TopComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'about', component: AboutComponent },
  { path: 'service', component: ServiceComponent },
  {
    path: 'complete',
    component: CompleteComponent,
    data: { animationState: 'detailPage' },
  },
  { path: 'jp', component: TopComponent },
  { path: 'contact/jp', component: ContactComponent },
  { path: 'about/jp', component: AboutComponent },
  { path: 'service/jp', component: ServiceComponent },
  {
    path: 'complete/jp',
    component: CompleteComponent,
    data: { animationState: 'detailPage' },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
